module.exports = __webpack_public_path__ + "img/map.6aa5dfdf.png";